{{infoTranslationKey | translate}}:
<br>
<b>{{otp}}</b>
